import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ver-contratos-empleados',
  templateUrl: './ver-contratos-empleados.component.html',
  styleUrls: ['./ver-contratos-empleados.component.css']
})
export class VerContratosEmpleadosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
